<template>
  <div class="search-wrap">
    <NavHeaderBar title="搜索" rightArrow />
    <SearchInput @search="onSearch" @cancel="onCancel" />
    <SearchHistory
      :keyList="historyKeys"
      @searchHistroy="onSearch"
      @deleteHistory="onDeleteHistory"
    />
  </div>
</template>

<script>
/**
 * ！！！！！注意
 * 本页为搜索历史记录页，只做历史记录的记录与实际搜索结果页的分发
 * 实际搜索结果页是SearchResult
 */
import { routerPush } from "@/config/locationRouter";
export default {
  name: "Search",
  data: () => ({
    historyKeys: []
  }),
  created() {
    // 读取本地缓存的搜索历史记录
    const keys = this.localDB.getItem("SEARCH_KEYS");
    if (keys !== null) {
      this.historyKeys = keys;
    }
  },
  methods: {
    onSearch(value) {
      // 前往搜索结果页
      routerPush({ path: "/searchResult", query: { key: value } });

      // 将有效的搜索关键词存入storage,并且避免重复
      if (!this.historyKeys.includes(value)) {
        // 历史记录超过15条，自动清除队列第一条
        this.historyKeys.length >= 15 && this.historyKeys.shift();
        this.historyKeys.push(value);
        this.localDB.setItem("SEARCH_KEYS", this.historyKeys);
      }
    },
    onDeleteHistory(value) {
      if (this.historyKeys.includes(value)) {
        const index = this.historyKeys.indexOf(value);
        this.historyKeys.splice(index, 1);
        this.localDB.setItem("SEARCH_KEYS", this.historyKeys);
      }
    },
    onCancel() {
      routerPush({ path: "/" });
    }
  }
};
</script>

<style lang="scss">
.search-wrap {
  padding-top: 46px;
}
</style>
